import { HeaderEvents, ProductProvidedData, ErtGlobalHeaderWindow } from 'navigator-header';
import { loggerFactory } from 'ert-logger';
import { publish } from 'ert-framebus';
import { PubSubMessages } from '../config';
import {inIframe, redirectToNavigator, startActivityTracking} from '../lib/tracking-activity';
import { createHeader } from './header.object';
import { clientId } from '../lib/header-script';

const logger = loggerFactory.createLogger('Global Header/bootstrap.ts');

// Parse query params (exporting for unit test)
export function getQueryParam(key: string): null | string {
  const url = location.href;
  const regex = new RegExp(`[?&#]${key}(=([^&#]*)|&|#|$)`),
      results = regex.exec(url);
  return (!results) ? null : (!results[2]) ? '' : decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Bootstrap the Navigator header API
export function bootstrap() {
    let state = getQueryParam('state');
    let stateRestored = false;
    const idToken = getQueryParam('id_token');
    const clientNavigatorStateKey = `${clientId}_navigator_state`;

    if (state) {
      publish(PubSubMessages.setState, state, true);
      if (idToken) {
        // store the state in the local storage to have it also available in new tabs
        localStorage.setItem(clientNavigatorStateKey, state);
      }
    } else {
      // if there is no state param available try to fetch it from the local storage (e.g. page opened in new tab)
      const navigatorState = localStorage.getItem(clientNavigatorStateKey);

      if (navigatorState) {
        state = navigatorState;
        stateRestored = true;
      }
    }

    if (idToken) {
      publish(PubSubMessages.idTokenData, idToken, 'location');
    }

    // We can fix the error message below once we drop support for
    // ie11 by adding 'unknown' conversion:
    // 'window as unknown as ErtGlobalHeaderWindow'
    const ertGlobalHeaderWindow = window as unknown as ErtGlobalHeaderWindow;
    setTimeout(() => {
      try {
        const header = createHeader();
        ertGlobalHeaderWindow.ertGlobalHeader = header;

        let productProvidedData: ProductProvidedData = {};
        if (ertGlobalHeaderWindow.ertGlobalHeaderReady) {

          productProvidedData = ertGlobalHeaderWindow.ertGlobalHeaderReady() || {};
          productProvidedData.productCode = productProvidedData.productCode || clientId;
          // if no state param is set, use local storage state
          if (!productProvidedData.state) {
            productProvidedData.rawState = state;
            productProvidedData.stateRestored = stateRestored;
          }
          publish(PubSubMessages.productProvidedData, productProvidedData);
          if (!productProvidedData.autoRedirectDisabled && !inIframe()) {
            redirectToNavigator(productProvidedData);
          }
        } else if (!inIframe()) {
          // client app doesn't provide production data
          productProvidedData.productCode = productProvidedData.productCode || clientId;
          productProvidedData.rawState = state;
          redirectToNavigator(productProvidedData);
        }

        // to retain flow existing in old header we do this after ertGlobalHeaderReady completed
        header.publish(HeaderEvents.afterRender);
        header.rendered = (cb: Function) => {
          try {
            cb();
          } catch (e) {
            logger.error(e);
          }
        };
      } catch (error) {
        logger.error(error);
      } finally {
        startActivityTracking();
      }
    }, 0);
}
